import { useState } from "react";
import { motion } from "framer-motion";
import Logo from "./icons/Logo";
import { HiMenu, HiX } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const handleNavClick = () => {
    navigate("/", { state: { scrollTo: "contact" } });
    setIsOpen(false);
  };

  const sideMenuVariants = {
    hidden: { x: "100%" },
    visible: {
      x: 0,
      transition: { type: "spring", stiffness: 300, damping: 30 },
    },
  };

  return (
    <>
      <header className="bg-primary py-7 px-11 fixed top-0 left-0 right-0 z-50">
        <nav className="flex justify-between items-center w-full">
          {/* Menu esquerdo (desktop) */}
          <div className="hidden md:flex gap-6">
            <ul className="flex gap-6">
              <li>
                <a href="#produtos">PRODUTOS</a>
              </li>
              <li>
                <a href="#papel-lavavel">PAPEL LAVÁVEL</a>
              </li>
              <li>
                <a href="#sobre">SOBRE</a>
              </li>
            </ul>
          </div>

          <a href="#" aria-label="Página inicial">
            <Logo className="md:w-[265px] md:h-[65px] w-[180px] h-[40px]" />
            <span className="sr-only">Página inicial</span>
          </a>

          <div className="flex items-center md:hidden">
            <button
              onClick={toggleMenu}
              className="text-white focus:outline-none"
              aria-label={isOpen ? "Fechar menu" : "Abrir menu"}
            >
              {isOpen ? (
                <HiX size={24} color="#000" />
              ) : (
                <HiMenu color="#000" size={24} />
              )}
            </button>
          </div>

          <div className="hidden md:flex gap-6">
            <ul className="flex gap-6">
              <li>
                <a href="#personalizacao">PERSONALIZAÇÃO</a>
              </li>
              <li>
                <button type="button" onClick={handleNavClick}>
                  FALE CONOSCO
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <motion.div
        initial="hidden"
        animate={isOpen ? "visible" : "hidden"}
        variants={sideMenuVariants}
        className="fixed top-0 right-0 bottom-0 w-3/4 max-w-xs bg-primary z-40 p-8"
      >
        <nav className="flex flex-col gap-6 mt-20">
          <a href="#produtos" onClick={toggleMenu}>
            PRODUTOS
          </a>
          <a href="#papel-lavavel" onClick={toggleMenu}>
            PAPEL LAVÁVEL
          </a>
          <a href="#sobre" onClick={toggleMenu}>
            SOBRE
          </a>
          <a href="#personalizacao" onClick={toggleMenu}>
            PERSONALIZAÇÃO
          </a>

          <div>
            <button type="button" onClick={handleNavClick}>
              FALE CONOSCO
            </button>
          </div>
        </nav>
      </motion.div>

      {isOpen && (
        <div
          onClick={toggleMenu}
          className="fixed inset-0 bg-black opacity-50 z-30"
        ></div>
      )}
    </>
  );
};

export default Header;
